const LoadingSkeleton = () => {
  return (
    <div className="category-grid">
      <div className="grouped-categories">
        {Array.from({ length: 4 }).map((_, blockIndex) => (
          <div key={blockIndex} className="category-block">
            <div className="category-block-header">
              <div className="skeleton-title"></div>
              <div className="skeleton-link"></div>
            </div>

            <div className="categories-grid">
              {Array.from({ length: 4 }).map((_, cardIndex) => (
                <div key={cardIndex} className="category-skeleton" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LoadingSkeleton
